/* eslint-disable react/no-unknown-property */
import { useEffect, useRef, useState } from "react";
import { BASE_DEV_URL, BASE_URL, IS_B2C } from "../../config/api.config";
import { useSelector } from "react-redux";
import { USER_DATA } from "../../config/app.config";
import { toastr } from "react-redux-toastr";

const PopupImage = ({ setOpen, auth, imgData }) => {
  const popupRef = useRef(null);

  const promotions = useSelector((state) => state.promotions.socials);
  let userData = {};

  try {
    userData = JSON.parse(localStorage.getItem(USER_DATA) || "{}");
  } catch {
    userData = {};
  }

  let { user_name, is_demo } = userData;

  // ⭐ CLOSE WHEN CLICK OUTSIDE
  const handleClickOutside = (e) => {
    if (popupRef.current && !popupRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const affiliateLink = `${BASE_URL}?af_code=${user_name}`;

  const copyAffiliateLink = () => {
    navigator.clipboard
      .writeText(affiliateLink)
      .then(() => {
        toastr.success("", "Link copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <div id="modal-root">
      <div
        className="fixed bottom-0 left-0 right-0 top-0 flex overflow-hidden z-[10000] h-[100dvh] w-dvw items-center justify-center bg-bg_color_popUpParentBg"
        id="PopUpMainContainer"
      >
        <div className="fixed inset-0 w-full h-full bg-black/10 backdrop-blur-sm" />
        <div
          ref={popupRef}
          className="relative p-0 xs:p-0 max-w-[90%] w-max sm:max-w-[85%] md:max-w-[70%] lg:max-w-[800px] max-w-[800px] relative bg-transparent popUpOpenAnimation1"
          role="dialog"
          aria-modal="true"
          title="undefined:Main Dialog"
        >
          <svg
            onClick={() => {
              setOpen(false);
            }}
            className="absolute top-1 right-1 z-10 h-6 w-6 cursor-pointer"
            height={24}
            width={24}
            aria-hidden="true"
            focusable="false"
            data-prefix="fad"
            data-icon="circle-xmark"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <g className="fa-duotone-group">
              <path
                fill="currentColor"
                d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
              />
              <path
                fill="white"
                d="M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"
              />
            </g>
          </svg>
          <div className="relative overflow-hidden w-full h-auto rounded-md md:rounded-[8px] bg-white">
            <img
              src={
                imgData?.self_host
                  ? `${BASE_DEV_URL}/${imgData?.content}`
                  : imgData?.content
              }
              alt={1}
              // sizes="(max-width: 600px) 100vw, (max-width: 800px) 50vw, 600px"
              className="  w-full h-full object-cover md:max-h-[600px]"
              loading="lazy"
              imgwidth={250}
              imgheight={100}
            />

            {!is_demo && IS_B2C && (
              <div className="p-4 space-y-3">
                <div>
                  <h2 className="text-base font-semibold text-gray-800">
                    Refer and Earn
                  </h2>
                  {/* <p className="text-xs text-gray-500">
                  Send this link to your friends and start earning
                </p> */}
                </div>

                <div className="flex items-center border-primary border-[2px] border-dashed gap-2  rounded-md p-1">
                  <textarea
                    value={affiliateLink}
                    readOnly
                    rows={2}
                    className="flex-1 bg-transparent text-sm outline-none px-2 resize-none break-words"
                  />
                  <button
                    onClick={copyAffiliateLink}
                    className={`px-3 py-1.5 rounded-lg text-sm font-medium transition bg-red-500 text-white hover:bg-red-600`}
                  >
                    Copy
                  </button>
                </div>

                {(promotions?.Whatsapp?.is_active ||
                  promotions?.Telegram?.is_active ||
                  promotions?.Instagram?.is_active) && (
                  <div className="flex items-center justify-between">
                    <p className="text-sm text-gray-600 mb-2 font-semibold">
                      Share via :{" "}
                    </p>

                    <div className="flex gap-2 align-items-center">
                      {promotions?.Whatsapp?.is_active && (
                        <a
                          href={`https://wa.me/?text=${encodeURIComponent(affiliateLink)}`}
                          target="_blank"
                          className="   rounded-xl text-sm"
                        >
                          {/* <img src="/what.webp" alt="whatsapp" /> */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 32 32"
                            fill="#22c55e"
                          >
                            <path
                              fill="#22c55e"
                              fill-rule="evenodd"
                              d="M24.504 7.504A11.875 11.875 0 0 0 16.05 4C9.465 4 4.1 9.36 4.1 15.945a11.882 11.882 0 0 0 1.594 5.973L4 28.109l6.336-1.664a11.958 11.958 0 0 0 5.71 1.457h.005c6.586 0 11.945-5.359 11.949-11.949c0-3.191-1.242-6.191-3.496-8.45zM16.05 25.883h-.004a9.93 9.93 0 0 1-5.055-1.383l-.363-.215l-3.762.985l1.004-3.665l-.234-.375a9.904 9.904 0 0 1-1.52-5.285c0-5.472 4.457-9.925 9.938-9.925a9.863 9.863 0 0 1 7.02 2.91a9.875 9.875 0 0 1 2.905 7.023c0 5.477-4.457 9.93-9.93 9.93zm5.445-7.438c-.297-.148-1.766-.87-2.039-.968c-.273-.102-.473-.149-.672.148c-.2.3-.77.973-.945 1.172c-.172.195-.348.223-.645.074c-.3-.148-1.261-.465-2.402-1.484c-.887-.79-1.488-1.77-1.66-2.067c-.176-.3-.02-.46.129-.61c.136-.132.3-.347.449-.523c.148-.171.2-.296.3-.496c.098-.199.048-.375-.027-.523c-.074-.148-.671-1.621-.921-2.219c-.243-.582-.489-.5-.672-.511c-.172-.008-.371-.008-.57-.008c-.2 0-.524.074-.798.375c-.273.297-1.043 1.02-1.043 2.488c0 1.469 1.07 2.89 1.22 3.09c.148.195 2.105 3.21 5.1 4.504a16.85 16.85 0 0 0 1.7.629c.715.226 1.367.195 1.883.12c.574-.085 1.765-.722 2.015-1.421c.247-.695.247-1.293.172-1.418c-.074-.125-.273-.2-.574-.352z"
                            />
                          </svg>
                        </a>
                      )}

                      {promotions?.Telegram?.is_active && (
                        <a
                          href={`https://t.me/share/url?url=${encodeURIComponent(affiliateLink)}`}
                          target="_blank"
                          className="  text-white  rounded-xl text-sm"
                        >
                          {/* <img src="/telegram-share.svg" alt="telegram-share" /> */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 24 24"
                            fill="#0ea5e9"
                          >
                            <path
                              fill="#0ea5e9"
                              d="m20.665 3.717l-17.73 6.837c-1.21.486-1.203 1.161-.222 1.462l4.552 1.42l10.532-6.645c.498-.303.953-.14.579.192l-8.533 7.701h-.002l.002.001l-.314 4.692c.46 0 .663-.211.921-.46l2.211-2.15l4.599 3.397c.848.467 1.457.227 1.668-.785l3.019-14.228c.309-1.239-.473-1.8-1.282-1.434z"
                            />
                          </svg>
                        </a>
                      )}

                      {promotions?.Instagram?.is_active && (
                        <a
                          href="https://www.instagram.com/"
                          target="_blank"
                          className="   text-white rounded-xl text-sm"
                        >
                          {/* <img
                            src="/instagram-share.svg"
                            alt="instagram-share"
                          /> */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            viewBox="0 0 256 256"
                          >
                            <g fill="none">
                              <rect
                                width="256"
                                height="256"
                                fill="url(#skillIconsInstagram0)"
                                rx="60"
                              />
                              <rect
                                width="256"
                                height="256"
                                fill="url(#skillIconsInstagram1)"
                                rx="60"
                              />
                              <path
                                fill="#fff"
                                d="M128.009 28c-27.158 0-30.567.119-41.233.604c-10.646.488-17.913 2.173-24.271 4.646c-6.578 2.554-12.157 5.971-17.715 11.531c-5.563 5.559-8.98 11.138-11.542 17.713c-2.48 6.36-4.167 13.63-4.646 24.271c-.477 10.667-.602 14.077-.602 41.236s.12 30.557.604 41.223c.49 10.646 2.175 17.913 4.646 24.271c2.556 6.578 5.973 12.157 11.533 17.715c5.557 5.563 11.136 8.988 17.709 11.542c6.363 2.473 13.631 4.158 24.275 4.646c10.667.485 14.073.604 41.23.604c27.161 0 30.559-.119 41.225-.604c10.646-.488 17.921-2.173 24.284-4.646c6.575-2.554 12.146-5.979 17.702-11.542c5.563-5.558 8.979-11.137 11.542-17.712c2.458-6.361 4.146-13.63 4.646-24.272c.479-10.666.604-14.066.604-41.225s-.125-30.567-.604-41.234c-.5-10.646-2.188-17.912-4.646-24.27c-2.563-6.578-5.979-12.157-11.542-17.716c-5.562-5.562-11.125-8.979-17.708-11.53c-6.375-2.474-13.646-4.16-24.292-4.647c-10.667-.485-14.063-.604-41.23-.604h.031Zm-8.971 18.021c2.663-.004 5.634 0 8.971 0c26.701 0 29.865.096 40.409.575c9.75.446 15.042 2.075 18.567 3.444c4.667 1.812 7.994 3.979 11.492 7.48c3.5 3.5 5.666 6.833 7.483 11.5c1.369 3.52 3 8.812 3.444 18.562c.479 10.542.583 13.708.583 40.396c0 26.688-.104 29.855-.583 40.396c-.446 9.75-2.075 15.042-3.444 18.563c-1.812 4.667-3.983 7.99-7.483 11.488c-3.5 3.5-6.823 5.666-11.492 7.479c-3.521 1.375-8.817 3-18.567 3.446c-10.542.479-13.708.583-40.409.583c-26.702 0-29.867-.104-40.408-.583c-9.75-.45-15.042-2.079-18.57-3.448c-4.666-1.813-8-3.979-11.5-7.479s-5.666-6.825-7.483-11.494c-1.369-3.521-3-8.813-3.444-18.563c-.479-10.542-.575-13.708-.575-40.413c0-26.704.096-29.854.575-40.396c.446-9.75 2.075-15.042 3.444-18.567c1.813-4.667 3.983-8 7.484-11.5c3.5-3.5 6.833-5.667 11.5-7.483c3.525-1.375 8.819-3 18.569-3.448c9.225-.417 12.8-.542 31.437-.563v.025Zm62.351 16.604c-6.625 0-12 5.37-12 11.996c0 6.625 5.375 12 12 12s12-5.375 12-12s-5.375-12-12-12v.004Zm-53.38 14.021c-28.36 0-51.354 22.994-51.354 51.355c0 28.361 22.994 51.344 51.354 51.344c28.361 0 51.347-22.983 51.347-51.344c0-28.36-22.988-51.355-51.349-51.355h.002Zm0 18.021c18.409 0 33.334 14.923 33.334 33.334c0 18.409-14.925 33.334-33.334 33.334c-18.41 0-33.333-14.925-33.333-33.334c0-18.411 14.923-33.334 33.333-33.334Z"
                              />
                              <defs>
                                <radialGradient
                                  id="skillIconsInstagram0"
                                  cx="0"
                                  cy="0"
                                  r="1"
                                  gradientTransform="matrix(0 -253.715 235.975 0 68 275.717)"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stop-color="#FD5" />
                                  <stop offset=".1" stop-color="#FD5" />
                                  <stop offset=".5" stop-color="#FF543E" />
                                  <stop offset="1" stop-color="#C837AB" />
                                </radialGradient>
                                <radialGradient
                                  id="skillIconsInstagram1"
                                  cx="0"
                                  cy="0"
                                  r="1"
                                  gradientTransform="matrix(22.25952 111.2061 -458.39518 91.75449 -42.881 18.441)"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stop-color="#3771C8" />
                                  <stop offset=".128" stop-color="#3771C8" />
                                  <stop
                                    offset="1"
                                    stop-color="#60F"
                                    stop-opacity="0"
                                  />
                                </radialGradient>
                              </defs>
                            </g>
                          </svg>
                        </a>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupImage;
